import {Link, useParams, useNavigate} from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import {postApi, setCookie} from '../../utils/functions';

import Blocks from '../components/bbcode/blocks';

import Col from 'react-bootstrap/Col';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';

import { FaKey } from "react-icons/fa6";
import { FaListAlt } from "react-icons/fa";
import { BsGraphUpArrow, BsCheck2 } from "react-icons/bs";
import { PiVideoFill } from "react-icons/pi";

export default function Radio() {

  const navigate = useNavigate();
  
  const [applications, setApplications] = useState([]);
  useEffect(() => {
    async function retrieveApplications() {
      let params = new URLSearchParams();
      const x = await postApi(`/v3/frontend/radio`, params);
      if( x.status === 200 ) {
        setApplications(x.data);
      } else {
        navigate("/");
      }
    }
    retrieveApplications();
  }, []);
  
  return (
    <main className="main">
      <section id="hero" className="hero hero-small section dark-background">
        <div className="hero-background">
          <img src="/images/bg-14.webp" alt="" data-aos-duration="1000" />
          <div className="overlay"></div>
        </div>
      </section>
      <section id="how-we-work" className="how-we-work section">
        <div className="container section-title">
          <h2>Apply Visual Radio</h2>
          <p>Open positions to join a voluntary radio station:</p>
        </div>
        <div className="container">
          <div className="row g-5">
            {applications.map((e, i)=>{
              return(
                <div key={i} className="step-card col-4">
                  <div className="step-icon-avatar">
                    <img src={`https://cloud.ultrastream.io/images/${e.avatar}`} />
                  </div>
                  <h3 className="mt-2">{e.title}</h3>
                  <Blocks id={`editor-${e.id}`} blocks={e.description} />
                  <Link to={`/apply/${e.title.toLowerCase().replaceAll(' ','-')}`}><div className="step-number mt-2">Apply</div></Link>
                </div>
              )
            })}
            <div className="step-card col-4">
              <div className="step-icon">
                <i className="bi bi-search"></i>
              </div>
              <h3>Research &amp; Planning</h3>
              <p>Nulla facilisi morbi tempus iaculis urna id. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere.</p>
              <div className="step-number mt-2">Apply</div>
            </div>
            <div className="step-card col-4">
              <div className="step-icon">
                <i className="bi bi-lightbulb"></i>
              </div>
              <div className="step-number">Step 2</div>
              <h3>Creative Solutions</h3>
              <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam.</p>
            </div>
            <div className="step-card col-4">
              <div className="step-icon">
                <i className="bi bi-gear"></i>
              </div>
              <div className="step-number">Step 3</div>
              <h3>Development</h3>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.</p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
